module.exports = __webpack_public_path__ + "img/selected2-min.b6fa4312.png";